import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import BrsrReportsCard from "../../../Cards/BrsrReportsCard";
import QuestionsForm from "../../QuestionsForm";
import submitForm from "../../../../api/test";
import { questionsWithSections } from "../../../../utils/schema/questionsWithSections";
import { saveFormData } from "../../../../redux/form/formSlice";

const BrsrCardWithForm = ({ cards }) => {
  const [currentCardIndex, setCurrentCardIndex] = useState(0);
  const [formData, setFormData] = useState({});
  const dispatch = useDispatch();
  const reduxFormData = useSelector((state) => state.form);
  const [errors, setErrors] = useState({});

  const currentCard = cards[currentCardIndex];
  const questionsForSection =
    questionsWithSections.data.find(
      (section) => section.sectionId === currentCard.id,
    )?.questions || [];

  useEffect(() => {
    if (reduxFormData[currentCard.id]) {
      setFormData((prev) => ({
        ...prev,
        [currentCard.id]: reduxFormData[currentCard.id],
      }));
    }
  }, [currentCard.id, reduxFormData]);

  const handleInputChange = (questionId, value) => {
    console.log("Handling input change for:", questionId);
    console.log("Value:", value);

    setFormData((prev) => {
      const updatedFormData = {
        ...prev,
        [currentCard.id]: {
          ...prev[currentCard.id],
          [questionId]: value,
        },
      };

      // Log the updated formData to check the value
      console.log(updatedFormData);

      return updatedFormData;
    });
  };

  const handleNext = (e) => {
    e.preventDefault();
    const sectionData =
      formData[currentCard.id] || reduxFormData[currentCard.id] || {}; // Fallback to reduxFormData if formData is empty
    const newErrors = {};

    // Validate all required fields
    // questionsForSection.forEach((q) => {
    //   if (!sectionData[q.questionId]) {
    //     newErrors[q.questionId] = `Please fill "${q.text}" before proceeding.`;
    //   }
    // });

    if (Object.keys(newErrors).length === 0) {
      dispatch(saveFormData({ sectionId: currentCard.id, data: sectionData }));
      if (currentCardIndex < cards.length - 1) {
        setCurrentCardIndex((prevIndex) => prevIndex + 1);
      }
    } else {
      setErrors(newErrors);

      // Scroll to the first invalid field
      const firstErrorFieldId = Object.keys(newErrors)[0];
      document
        .getElementById(firstErrorFieldId)
        ?.scrollIntoView({ behavior: "smooth" });
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const sectionData =
      formData[currentCard.id] || reduxFormData[currentCard.id] || {}; // Fallback to reduxFormData if formData is empty
    const newErrors = {};

    // Validate all required fields
    questionsForSection.forEach((q) => {
      if (!sectionData[q.questionId]) {
        newErrors[q.questionId] = `Please fill "${q.text}" before submitting.`;
      }
    });

    if (Object.keys(newErrors).length === 0) {
      dispatch(saveFormData({ sectionId: currentCard.id, data: sectionData }));
      const payload = Object.entries(reduxFormData).map(
        ([sectionId, data]) => ({
          id: sectionId,
          answers: Object.entries(data).map(([questionId, value]) => ({
            questionId,
            value,
          })),
        }),
      );
      await submitForm(payload);
    } else {
      setErrors(newErrors);

      // Scroll to the first invalid field
      const firstErrorFieldId = Object.keys(newErrors)[0];
      document
        .getElementById(firstErrorFieldId)
        ?.scrollIntoView({ behavior: "smooth" });
    }
  };

  const handlePrevious = (e) => {
    e.preventDefault();
    if (currentCardIndex > 0) {
      setCurrentCardIndex((prevIndex) => prevIndex - 1);
    }
  };

  const filterQuestions = (questions) => {
    return questions.filter((question) => {
      if (question.condition) {
        const { questionId, value } = question.condition;
        return formData[currentCard.id]?.[questionId] === value;
      }
      return true;
    });
  };

  const renderQuestions = () => {
    const filteredQuestions = filterQuestions(questionsForSection);
    return (
      <QuestionsForm
        questions={filteredQuestions}
        formData={formData[currentCard.id] || {}}
        errors={errors}
        onInputChange={handleInputChange}
      />
    );
  };

  return (
    <div>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 mb-6">
        {cards.map((card, index) => (
          <BrsrReportsCard
            key={card.id}
            value={card.id}
            cardTitle={card.title}
            count={index + 1}
            selectedValue={cards[currentCardIndex]?.id}
            onChange={() => setCurrentCardIndex(index)}
          />
        ))}
      </div>

      <form>
        {renderQuestions()}
        <div className="flex justify-between mt-4">
          <button
            onClick={handlePrevious}
            disabled={currentCardIndex === 0}
            className="px-4 py-2 bg-gray-300 text-gray-700 rounded"
          >
            Previous
          </button>
          {currentCardIndex < cards.length - 1 ? (
            <button
              onClick={handleNext}
              className="px-4 py-2 bg-blue-500 text-white rounded"
            >
              Next
            </button>
          ) : (
            <button
              onClick={handleSubmit}
              className="px-4 py-2 bg-green-500 text-white rounded"
            >
              Submit
            </button>
          )}
        </div>
      </form>
    </div>
  );
};

export default BrsrCardWithForm;
